import styled from "styled-components";
import { LicenceTypePurchase } from "../../../types/Licences/LicenceTypePurchase";
import LicenceLayerAccess from "./LicenceLayerAccess";
import { Layer } from "../../../types/Layer";
import { Currency } from "../../../types/Currency/Currency";
import LicencePricing from "./LicencePricing";
import ConcurrentFooter from "./ConcurrentFooter";
import { branding } from "./branding";
import { Button, Spinner } from "react-bootstrap";
import { usePurchaseLicenceContext } from "../../../context/PurchaseLicence/PurchaseLicenceContext";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
  height: 100%;
  width: 325px;
  gap: 1rem;
`;

const LicenceCardHeader = styled.div`
  border-bottom: 1px solid #ccc;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`;

const LicenceCardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 1rem;
  background-color: white;
  flex-grow: 1;
`;

const LicenceCardFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1rem;
`;

const LicenceCardPricing = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`;

interface LicenceCardProps {
  licence: LicenceTypePurchase;
  allLayers: Layer[];
  transactionCurrency: Currency;
}

const LicenceCard = ({ licence, allLayers }: LicenceCardProps) => {
  const { loading, onPurchaseLicence } = usePurchaseLicenceContext();

  const brand = branding.find((b) =>
    licence.name.toLowerCase().includes(b.name.toLowerCase())
  );

  const name = licence.name.replace(/\s*\(.*?\)\s*/g, "").trim();

  return (
    <Container className="bg-light" key={licence.softwareLicenceId}>
      <LicenceCardHeader className={brand?.className}>
        <h5 className="mb-0">{name}</h5>
      </LicenceCardHeader>
      <LicenceCardContent className="bg-light">
        <LicenceLayerAccess
          allLayers={allLayers}
          availableLayers={licence.accessibleLayers}
        />
        <LicenceCardPricing className="bg-light">
          {<LicencePricing licence={licence} />}
        </LicenceCardPricing>
      </LicenceCardContent>
      <LicenceCardFooter className={`${brand?.className}-footer`}>
        {licence.licenceType === "Concurrent" ? (
          <ConcurrentFooter licence={licence} />
        ) : (
          <Button
            onClick={() =>
              onPurchaseLicence(licence.softwareLicenceId, licence.licenceType)
            }
            disabled={loading}
          >
            {loading ? <Spinner variant="border" /> : "Purchase"}
          </Button>
        )}
      </LicenceCardFooter>
    </Container>
  );
};

export default LicenceCard;
